import { Vue, Component } from 'vue-property-decorator'
import articulos from '@/store/modules/ArticuloModule'
import { Articulo } from '@/types/types'

@Component
export default class ImageUpload extends Vue {
  imageOpen = false
  image = ''

  search= ''

  get articulos () {
    return articulos.items
  }

  current = articulos.service.getEmpty()

  headers = [
    {
      text: 'Codigo',
      value: 'codigo_sistema'
    },
    {
      text: 'Nombre',
      value: 'nombre'
    },
    {
      text: 'Marca',
      value: 'marca.nombre'
    },
    {
      text: '...',
      value: 'actions'
    }
  ]

  onOpenImage (articulo: Articulo) {
    this.current = articulo
    this.imageOpen = true
  }

  selectImage (file: File) {
    if (!file) {
      return
    }
    this.createImage(file)
  }

  createImage (file: File) {
    const reader = new FileReader()
    reader.onload = (e) => {
      this.image = (e.target?.result as string)
    }
    reader.readAsDataURL(file)
  }

  saveImage () {
    articulos.service.uploadImage({
      image: this.image,
      id: this.current.id
    }).then(() => {
      this.image = ''
      this.imageOpen = false
      alert('Imagen Subida')
    })
  }

  toggleEnable (id: string, estado: number) {
    console.log(id, estado)
  }

  mounted () {
    articulos.fetchAll('')
  }
}
